module.exports = __webpack_public_path__ + "img/bt.927ecffd.svg";